// getMessageDrmMediaSource.js
'use strict';
import { Collection } from 'immutable';
import createCachedSelector from '../resource/createCachedSelector.js';

import {
  getAssetManifest,
  getAssetTrailer,
  MediaAssetFormat,
  MediaPreset,
} from '../resource/getMediaAsset.js';

/**
 * Select drm media source by
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} messageId - message id.
 * @param {string} dataKey - data key.
 * @param {string} pathname - location pathname.
 * @return {any} The selected drm media source.
 */
const getMessageDrmMediaSource = createCachedSelector(
  (state, messageId) => messageId,
  (state, messageId) => state.getIn(['messages', messageId]),
  (state, messageId, assetId) => assetId,
  (state, messageId, assetId, dataKey) => dataKey,
  (messageId, message, assetId, dataKey) => {
    let result = undefined;
    if ('drmMediaSource' === dataKey) {
      const viewScope = message?.get('viewScope') || 'preview';
      const mp4Url = getAssetTrailer({
        id: messageId,
        assetId,
        format: MediaAssetFormat.MP4,
        preset: MediaPreset.SD,
      }).href;
      result = {
        dash: getAssetManifest({
          id: messageId,
          assetId,
          format: MediaAssetFormat.MPD,
          preset: viewScope === 'sd' ? MediaPreset.SD : MediaPreset.SD_PREVIEW,
        }).href,
        hls: getAssetManifest({
          id: messageId,
          assetId,
          format: MediaAssetFormat.M3U8,
          preset: viewScope === 'sd' ? MediaPreset.SD : MediaPreset.SD_PREVIEW,
        }).href,
        mp4: mp4Url,
      };
    }
    return result instanceof Collection ? result.toJS() : result;
  }
)(
  (state, messageId, dataKey) =>
    `getMessageDrmMediaSource:${messageId}:${dataKey}`
);

export default getMessageDrmMediaSource;
